module.exports = __webpack_public_path__ + "media/images/humidity-indicator-muted-1-74f9701404ce9e40eecd88a529b42fa0.svg";